import { action } from 'satcheljs';

export const sendWelcomeToPubcenterEmail = action('sendWelcomeToPubcenterEmail');

